export default {"container":"_container_11vsc_1","videoWrapper":"_videoWrapper_11vsc_10"};